import { Product } from '../types/Product';

export const products: Product[] = [
  {
    id: 'block-pedal',
    name: 'Block Pedal',
    arabicName: 'بلوك دواسة',
    image: 'https://i.ibb.co/4ZmHmKJd/Whats-App-Image-2025-09-10-at-3-04-51-PM.jpg',
    images: [
      'https://i.ibb.co/4ZmHmKJd/Whats-App-Image-2025-09-10-at-3-04-51-PM.jpg',
      'https://i.ibb.co/Zp396GD2/Whats-App-Image-2025-09-12-at-15-30-53.jpg'
    ],
    price: 59.900,
    originalPrice: 79.900,
    description: 'جهاز مكافحة السرقة الأكثر فعالية وموثوقية. يمنع تحريك السيارة بشكل كامل.',
    features: ['تركيب في دقيقتين', 'متوافق مع جميع السيارات', 'مقاوم للكسر', 'ضمان سنة كاملة'],
    badge: 'الأكثر مبيعاً',
    rating: 4.9,
    reviews: 1247,
    isPopular: true
  },
  {
    id: 'cadenas-alarm',
    name: 'Cadenas Alarm',
    arabicName: 'قفل إنذار',
    image: 'https://i.ibb.co/whNMSK8j/image-11.png',
    images: [
      'https://i.ibb.co/whNMSK8j/image-11.png',
    ],
    price: 59.900,
    originalPrice: 79.900,
    description: 'قفل ذكي مع نظام إنذار صوتي قوي. حماية إضافية لسيارتك.',
    features: ['إنذار صوتي 120 ديسيبل', 'مقاوم للماء', 'بطارية طويلة المدى', 'سهل الاستخدام'],
    badge: 'جديد',
    rating: 4.9,
    reviews: 1247,
    isPopular: true
  },
  {
    id: 'block-pedal-2x1',
    name: 'Block Pedal 2x1',
    arabicName: 'بلوك دواسة عرض خاص',
    image: 'https://i.ibb.co/bjWs7K8G/Whats-App-Image-2025-09-25-at-15-10-03.jpg',
    images: [
      'https://i.ibb.co/bjWs7K8G/Whats-App-Image-2025-09-25-at-15-10-03.jpg',
    ],
    price: 59.900,
    originalPrice: 79.900,
    description: 'جهاز مكافحة السرقة الأكثر فعالية وموثوقية. يمنع تحريك السيارة بشكل كامل.',
    features: ['تركيب في دقيقتين', 'متوافق مع جميع السيارات', 'مقاوم للكسر', 'ضمان سنة كاملة'],
    badge: 'الأكثر مبيعاً',
    rating: 4.9,
    reviews: 1247,
    isPopular: true
  },
  {
    id: 'bloc-pedal-alarme',
    name: 'Bloc Pedal Alarme',
    arabicName: 'بلوك دواسة مع إنذار',
    image: 'https://i.ibb.co/mC1dz3XC/Whats-App-Image-2025-09-25-at-15-10-16.jpg',
    images: [
      'https://i.ibb.co/mC1dz3XC/Whats-App-Image-2025-09-25-at-15-10-16.jpg',
    ],
    price: 79.900,
    originalPrice: 99.900,
    description: 'الحل الأمثل: بلوك دواسة مع نظام إنذار مدمج. حماية مضاعفة لسيارتك.',
    features: ['حماية مضاعفة', 'إنذار مدمج', 'تقنية متطورة', 'سهل التركيب'],
    badge: 'متطور',
    rating: 4.9,
    reviews: 1247,
    isPopular: true
  },
  {
    id: 'bloc-volant',
    name: 'Bloc volant',
    arabicName: 'بلوك عجلة القيادة',
    image: 'https://i.ibb.co/QvYR0VJt/Whats-App-Image-2025-11-08-at-13-52-54.jpg',
    images: [
      'https://i.ibb.co/QvYR0VJt/Whats-App-Image-2025-11-08-at-13-52-54.jpg',
    ],
    price: 69.900,
    originalPrice: 89.900,
    description: 'مانع عجلة القيادة المطور. يمنع تماماً دوران عجلة القيادة مما يجعل السيارة غير قابلة للقيادة.',
    features: ['تركيب في 30 ثانية', 'قفل عجلة قيادة متين', 'مفتاح أمان فريد', 'مقاوم للصدأ', 'ضمان سنة كاملة'],
    badge: 'جديد',
    rating: 4.9,
    reviews: 1247,
    isPopular: true
  },
  {
    id: 'support',
    name: 'Support',
    arabicName: 'سبورت',
    image: 'https://i.ibb.co/RpLHcvhn/Whats-App-Image-2025-11-09-at-11-21-31.jpg',
    images: [
      'https://i.ibb.co/RpLHcvhn/Whats-App-Image-2025-11-09-at-11-21-31.jpg',
    ],
    price: 33.000,
    originalPrice: 39.900,
    description: 'داعم قوي ومتين لتثبيت البلوك أو الأقفال على السيارة بسهولة وأمان.',
    features: ['مادة عالية الجودة', 'مناسب لجميع الأنواع', 'تصميم عملي ومتين'],
    badge: 'عملي',
    rating: 4.8,
    reviews: 378,
    isPopular: false
  },
  {
    id: 'grand-support',
    name: 'Grand Support',
    arabicName: 'سبورت كبير',
    image: 'https://i.ibb.co/ZprHBCPL/Gemini-Generated-Image-z12niz12niz12niz.png',
    images: [
      'https://i.ibb.co/ZprHBCPL/Gemini-Generated-Image-z12niz12niz12niz.png',
    ],
    price: 33.000,
    originalPrice: 39.900,
    description: 'سبورت كبير الحجم يوفر ثباتًا إضافيًا للبلوك، مناسب للمركبات الكبيرة.',
    features: ['قوي ومتين', 'مناسب للمركبات الكبيرة', 'تصميم محسّن للاستقرار'],
    badge: 'مميز',
    rating: 4.8,
    reviews: 412,
    isPopular: false
  },
  {
    id: 'cadenas',
    name: 'Cadenas',
    arabicName: 'قفل',
    image: 'https://i.ibb.co/BKHtH0M9/Whats-App-Image-2025-10-14-at-21-40-18.jpg',
    images: [
      'https://i.ibb.co/BKHtH0M9/Whats-App-Image-2025-10-14-at-21-40-18.jpg',
    ],
    price: 23.900,
    originalPrice: 29.900,
    description: 'قفل معدني متين للحماية الإضافية من السرقة. مثالي للاستخدام اليومي.',
    features: ['قوي ومتين', 'مقاوم للصدأ', 'تصميم صغير وسهل الاستخدام'],
    badge: 'الأكثر طلباً',
    rating: 4.7,
    reviews: 529,
    isPopular: true
  }
];
